import * as React from 'react';
import {Types} from 'Models/VehicleModel';
import * as Dictionary from 'Models/Dictionary';
import * as VehicleEnumTypes from 'Models/EnumTypes/VehicleEnumTypes';
import {TimeDisplayFormat} from "Models/EnumTypes/HistoryEnumTypes";
import * as HistoryModule from 'Modules/HistoryModule';
import * as AlertModule from 'Modules/AlertModule';
import * as AOIModule from 'Modules/AOIModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import moment from 'moment';
import * as L from 'leaflet';
import {LatLngExpression} from 'leaflet';
import Slider from 'react-slick';
import i18n from '../../../../Translations/_i18n';
import {CarCategory} from '../../../../Models/EnumTypes/VehicleEnumTypes';
import {SimplifiedFleetDTO} from "Models/FleetModel";

export const Coordinates = (props: Types.Coords) => (
    <div className="annotation bold">
        {props.lat} {props.lat > 0 ? 'N' : 'S'} <i
        className="icon icon--dot icon--dot__blue"/> {props.lng} {props.lng > 0 ? 'E' : 'W'}
    </div>
);
export const DateTimeComponent = (props: { date: string; type?: 'blue' | 'gray'; alignLeft?: boolean }) => (
    <span className={`annotation ${props.alignLeft ? 'annotation--left' : ''}`}>
        <i className={props.type && props.type == 'blue' ? 'icon icon--calendar_blue' : `icon icon--calendar`}/> {moment(props.date).format('YYYY-MM-DD')}{' '}
        <i className={props.type && props.type == 'blue' ? 'icon icon--watch_blue' : `icon icon--watch_grey`}/>
        {moment(props.date).format('HH:mm')}
    </span>
);
export const DateComponent = (props: { date: string; type?: 'blue' | 'gray'; includeHours?: boolean; alignLeft?: boolean }) => (
    <div className={`annotation ${props.alignLeft ? 'annotation--left' : ''}`}>
        <i className={props.type && props.type == 'blue' ? 'icon icon--calendar_blue' : `icon icon--calendar`}/>{' '}
        {props.includeHours ? moment(props.date).format('HH:mm:ss, DD.MM.YYYY') : moment(props.date).format('DD.MM.YYYY')}
    </div>
);
export const DistanceComponent = (props: { mileage: number }) => (
    <div>
        <span className="icon icon--mileage"/>
        {props.mileage.toFixed(2)} km
    </div>
);

export const DurationComponent = (props: { durationSeconds: number; inline?: boolean; noIcon?: boolean }) => {
    return (
        <span style={props.inline ? {display: 'inline-block'} : {}}>
            {!props.noIcon && <i className="icon icon--stopper"/>}
            {returnTimeFromSeconds(props.durationSeconds, TimeDisplayFormat.DESCRIPTIVE)}
        </span>
    );
};

export const generateSpeedLimitEnum = (currentSpeed: number, allowedSpeed: number): VehicleEnumTypes.VehicleSpeedEnum => {
    const {RED, YELLOW, GREY, GREEN} = VehicleEnumTypes.VehicleSpeedEnum;
    const calculatedDiff = currentSpeed - allowedSpeed;
    switch (true) {
        case calculatedDiff > 15 && calculatedDiff <= 30: {
            return YELLOW;
        }
        case calculatedDiff > 30: {
            return RED;
        }
        case calculatedDiff <= 15: {
            return GREEN;
        }
        default:
            return GREY;
    }
};

export const VehicleSpeedIcons = (props: { allowedSpeed: number; currentSpeed: number; turnedOn: boolean; speedLimitExceedance: VehiclesModule.EnumTypes.VehicleSpeedEnum }) => {
    return (
        <div className="car-details__speedometers">
            <div className="car-details__speed-img">
                <img src={Dictionary.SpeedometerImage.get(props.speedLimitExceedance)}/>
                <span className="car-details__speed-txt">{props.turnedOn ? props.currentSpeed : 'P'}</span>
            </div>
            {props.turnedOn &&
            <div className="car-details__speed-sign">{props.allowedSpeed ? props.allowedSpeed : '-'}</div>}
        </div>
    );
};

export const VehicleSpeedImage = (props: {
    carCategory: VehicleEnumTypes.CarCategory;
    turnedOn: boolean;
    speedLimitExceedance: VehiclesModule.EnumTypes.VehicleSpeedEnum;
}) => {
    return (
        <div className="speed-limit-img">
            <img className={`speed-limit-img__road ${props.turnedOn ? '' : 'speed-limit-img__road--off'}`}
                 src={Dictionary.SpeedLimitRoadImage.get(props.speedLimitExceedance)} alt=""/>
            <img
                className={`speed-limit-img__car ${props.turnedOn ? '' : 'speed-limit-img__car--off'}`}
                src={props.turnedOn ? Dictionary.CarCategoryImage.get(props.carCategory) : Dictionary.TurnedOffCarCategoryImage.get(props.carCategory)}
                alt=""
            />
        </div>
    );
};

export function returnTimeFromSeconds(seconds: number, displayType: TimeDisplayFormat = TimeDisplayFormat.NUMERIC): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds - hours * 3600) / 60);
    const secs = seconds - hours * 3600 - minutes * 60;
    return formatTimeFromSeconds(hours, minutes, secs, displayType);
}

export function formatTimeFromSeconds(hours: number, minutes: number, seconds: number, displayType: TimeDisplayFormat): string {
    let timeString;
    if (hours < 48) {
        switch (displayType) {
            case TimeDisplayFormat.DESCRIPTIVE: {
                timeString = `${hours}h ${minutes}m ${seconds}s`;
                break;
            }
            default: {//NUMERIC
                timeString = `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`;
            }
        }
    } else {
        timeString = i18n.t('carDetails:overNDays').replace('_n_', String(Math.floor(hours / 24)));
    }

    return timeString;
}

export function createArrayOfPoints(ridePathArray: Array<HistoryModule.Types.PathPoint>): Array<LatLngExpression> {
    const LatLangExpression: Array<LatLngExpression> = [];
    ridePathArray.forEach((e, i) => {
        LatLangExpression.push([e.latitude, e.longitude]);
    });
    return LatLangExpression;
}

export function createArrayOfPointsFromDataFrames(dataframesArr: Array<VehiclesModule.Types.CarDataframeDto>): Array<LatLngExpression> {
    const LatLangExpression: Array<LatLngExpression> = [];
    dataframesArr.forEach((e, i) => {
        LatLangExpression.push([e.latitude, e.longitude]);
    });
    return LatLangExpression;
}

export function LeafletIconCreator(iconPath: string, heading: number = 0, size = {x: 25, y: 25}) {
    return L.divIcon({
        iconUrl: iconPath,
        iconSize: [size.x, size.y],
        html: `<img style="transform: rotate(${heading}deg)"src=${iconPath}>`,
        className: iconPath
            .split('/')
            .pop()
            .split('.')[0]
    });
}

export function LeafletIconCreatorNoImage(heading: number = 0, size = {x: 25, y: 25}, className: string = '') {
    return L.divIcon({
        iconSize: [size.x, size.y],
        html: `<div class=${className} style="transform: rotate(${heading}deg)"/>`,
        className: `${className}--wrapper` || 'no_image_icon'
    });
}

export function createCoordsXYZ(latLngArr: Array<LatLngExpression>): Array<AOIModule.Types.Coordinate> {
    const coordinateArr: Array<AOIModule.Types.Coordinate> = [];
    latLngArr.forEach((element, idx) => {
        coordinateArr.push({
            x: element[0],
            y: element[1]
        });
    });
    // ponowne dodanie 1 elementu na potrzeby API
    coordinateArr.push({
        x: latLngArr[0][0],
        y: latLngArr[0][1]
    });
    return coordinateArr;
}

export const DistanceElement = (props: { title: string; distance: number; dateFrom: string; dateTo: string; rightHalf?: boolean }) => (
    <div
        className={`car-details__half car-details__half--block ${props.rightHalf ? 'car-details__half--dist-col-right' : ''}`}>
        <h4 className="heading--light">{props.title}</h4>
        {props?.distance !== undefined ? <p>{props.distance.toFixed(2)} km</p> :
            <div className="loader__inner loader__inner--one-line"/>}
        <p className="date font-xs font-blue bold">
            {props.dateFrom} - {props.dateTo}
        </p>
    </div>
);
export const CarPathComponent = (props: {
    carCategory: CarCategory,
    mileageGps: number,
    speedGps: number,
    turnedOn: boolean,
    speedLimitKmh: number,
    t: Function;
    onTourSince: string,
    durationSeconds: number,
    endDate: string,
    startDate: string
}) => {
    const {
        startDate,
        endDate,
        durationSeconds,
        carCategory,
        mileageGps,
        speedGps,
        speedLimitKmh,
        turnedOn,
        t,
        onTourSince
    } = props;
    return (
        <div
            className={`car-details__element flex flex--space-between ${turnedOn ? '' : 'carDetailsComposite__turned-off'}`}
        >
            <div className="car-details__half car-details__half--block car-details__half--image">
                <div className="mb-7">
                    <h4 className="heading--light">{t('allowedSpeed')}</h4>
                    <h4 className="heading">{speedLimitKmh ? `${speedLimitKmh} km/h` : 'b/d'}</h4>
                </div>
                <div className="mb-7">
                    <h4 className="heading--light">{t('vehicleSpeed')}</h4>
                    <h4 className="heading">{speedGps || speedGps >= 0 ? `${speedGps} km/h` : 'b/d'}</h4>
                </div>

                <div className="mb-7">
                    <h4 className="heading--light">{t('mileage')}</h4>
                    <h4 className="heading">{mileageGps ? `${mileageGps} km` : 'b/d'}</h4>
                </div>
                <div className="car-details__half--car-img">
                    <img width="25" src={Dictionary.CarCategoryImageNoShadow.get(carCategory)} alt=""/>
                </div>
            </div>
            <div className="car-details__half car-details__half--block car-details__half--opposite">
                {turnedOn ? (
                    <>
                        <i className="icon icon--parking car-details__parking-icon"/>
                        <div className="mb-7">
                            <h4 className="heading--light">{t('inRideFromNow')}</h4>
                            <h4 className="heading heading--clear-margin">
                                {onTourSince ?
                                    <DurationComponent durationSeconds={moment().diff(moment(onTourSince), "seconds")}
                                                       noIcon/> : "-"}
                            </h4>
                        </div>
                        <div className="mb-7">
                            <h4 className="heading--light">{t('latestStop')}</h4>
                            <h4 className="heading heading--clear-margin">
                                <DurationComponent durationSeconds={durationSeconds ? durationSeconds : 600} noIcon/>
                            </h4>
                            <p className="date font-xs font-blue bold">{endDate ? `${moment(endDate).format('hh:mm')} ${moment(endDate).format('DD.MM.YYYY')}` : '-'}</p>
                        </div>
                    </>
                ) : (
                    <div className="mb-7">
                        <h4 className="heading--light">{t('stopSince')}</h4>
                        <h4 className="heading heading--clear-margin">{durationSeconds ?
                            <DurationComponent durationSeconds={durationSeconds} noIcon/> : '00:21:14'}</h4>
                        <div
                            className="date font-xs font-blue bold">{startDate ? `${moment(startDate).format('HH:mm')} ${moment(startDate).format('DD.MM.YYYY')}` : '-'}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

type AlertBlockP = {
    title: string;
    alertList: Array<AlertModule.Types.AlertDefinitionDto>;
    iconSrc: string;
    t: (key: string) => string;
};

export const AlertBlock = (props: AlertBlockP) => {
    const {SPEEDING} = AlertModule.EnumTypes.AlertCondition;
    return (
        <div className="alerts__single">
            <div className="alerts__single-head">
                <img src={props.iconSrc} alt={props.title} className="alerts__single-icon"/>
                <span className="bold">{props.title}</span>
                <span className="alerts__single-count">
                    {props.t('alertsCount')}: {props.alertList.length}
                </span>
            </div>
            <div className="alerts__list">
                {props.alertList.length > 0 &&
                props.alertList.map((alert, idx) => {
                    return (
                        <div className="alerts__item" key={idx}>
                            <div className="alerts__item-title">
                                <h4 className="alerts__item-title-left">{alert.name}</h4>
                                <div className="alerts__item-icons">
                                    <i className={`icon icon--email mr-7 ${alert.notifyByEmail ? '' : 'icon--lighter'}`}/>
                                    <i className={`icon icon--system-notification mr-7 ${alert.notifyBySystemNotification ? '' : 'icon--lighter'}`}/>
                                    <i className={`icon icon--sms mr-7 ${alert.notifyBySms ? '' : 'icon--lighter'}`}/>
                                </div>
                            </div>
                            <div className="alerts__condition">
                                <p className="bold">
                                    {Dictionary.AlertConditionDictionaryMap.get(alert.alertCondition)} {alert.alertCondition === SPEEDING ? ` > ${alert.conditionValue}` : ''}
                                </p>
                                <p>{alert.message}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export type FleetBlockP = {
    fleets: Array<SimplifiedFleetDTO>;
};
const _fleetMap = (fleet: SimplifiedFleetDTO, i: number) => {
    if (!fleet) {
      return null
    }

    return (
        <div className="fleet__slider-single-wrapper" key={`singleFleet-${i}`}>
            <div className={`fleet__slider-single ${fleet.name.length > 14 ? 'fleet__show-overflow' : ''}`}>
                <div className="fleet__slider-single-inner">
                    <span className="bold">{fleet.numberOfCars}</span>
                    <span className="pl-5">
                        {fleet.name.substring(0, 14)}
                        {fleet.name.length > 14 ? '...' : ''}
                    </span>
                </div>

                {fleet.name.length > 14 &&
                <div className="fleet__slider-single-inner--expand">
                    <span className="bold">{fleet.numberOfCars}</span>
                    <span className="pl-5">
                        {fleet.name}
                    </span>
                </div>
                }
            </div>
        </div>
    );
}

export const FleetBlock = (props: FleetBlockP) => {
    const settings = {
        dots: false,
        arrows: true,
        // infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1
    };
    if (props.fleets.length >= 3) {
        return (
            <div className="fleet fleet__slider">
                <Slider {...settings}>
                    {props.fleets.map(_fleetMap)}
                </Slider>
            </div>
        );
    }

    if (props.fleets.length > 0 && props.fleets.length < 3) {
        return (
            <div className="fleet__slider fleet__slider--no-slider">
                {props.fleets.map(_fleetMap)}
            </div>
        );
    }
    return null;
};

export const AlertHistoryBlock = (props: { alert: AlertModule.Types.AlertHistorySingleLogDto }) => {
    const {alert} = props;
    const {SPEEDING} = AlertModule.EnumTypes.AlertCondition;
    return (
        // <div className="alertHistoryBlock" onClick={() => history.push(`${Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.ALERTS)}/${alert.alertDefinitionId}`)}>
        <div className="alerts__item alerts__item--history">
            <div className="alerts__item-title">
                <h4 className="alerts__item-title-left alerts__item-title-left--smaller">{alert.title}</h4>
                <div className="alerts__item-title-right">{moment(alert.invokeDate).format('h:mm:ss, DD.MM.YYYY')}</div>
            </div>
            <div className="alerts__condition">
                <p>{Dictionary.AlertConditionDictionaryMap.get(alert.alertCondition)} {alert.alertCondition === SPEEDING ? ` > ${alert.conditionValue}` : ''}</p>
                <p>{alert.message} </p>
            </div>
        </div>
    );
};

export const CarNameBlock = (props: {
    carName: string,
    licensePlate: string,
    carImageSource?: string,
    noCarPhotosAvailable: boolean,
    noImageAvailableInfo: string
}) => {
    const {carName, licensePlate, carImageSource, noCarPhotosAvailable, noImageAvailableInfo} = props
    const [carImageVisible, setCarImageVisible] = React.useState(false);
    return (
        <div
            className="carDetailsComposite__relative carDetailsComposite__element carDetailsComposite--twoCol carDetailsComposite--align_center carDetailsComposite__grey carDetailsComposite__no-border">
            <div className="carDetailsComposite--twoCol-left carDetailsComposite__halfWidth">
                <div className="form_field form_field--sm">
                    <input
                        type="text"
                        disabled
                        value={carName}
                    />
                </div>
            </div>

            <div className="carDetailsComposite--twoCol-right carDetailsComposite__halfWidth carDetailsComposite__flex">
                <div className="carDetailsComposite__plate">{licensePlate}</div>
                {
                    noCarPhotosAvailable &&
                    <div className="btn btn--clean carDetailsComposite__button--center">
                        <img src="/images/icons/add_image.svg" width="15" alt=""
                             onClick={() => setCarImageVisible(true)}/>
                    </div>
                }

                {carImageVisible && (
                    <div className="carDetailsComposite__image-popup">
                        {!noCarPhotosAvailable ? (
                            <>{carImageSource ? <img src={carImageSource} alt=""/> :
                                <div className="loader__inner loader__inner--sm"/>}</>
                        ) : (
                            <h4 className="bold text-center">{noImageAvailableInfo}</h4>
                        )}
                        <div className="icon--exit" onClick={() => setCarImageVisible(false)}/>
                    </div>
                )}
            </div>
        </div>
    )
}


export const CarVinBlock = (props: {
    vin: string,
    deviceId: string,
    labelCarId: string
}) => {
    const {vin, deviceId, labelCarId} = props;
    return (
        <div
            className="carDetailsComposite__element carDetailsComposite--twoCol carDetailsComposite__grey carDetailsComposite__no-border">
            {/* <div className="carDetailsComposite__twoThirds"> */}
            <div className="carDetailsComposite__element carDetailsComposite__no-border">
                <h4 className="heading--sm">{labelCarId}</h4>
                <h4>
                    {vin} [{deviceId}]
                </h4>
            </div>
        </div>
    )
}

export const CarAdressBlock = (props: {
    addressDisplayName: string,
    latitude: number,
    longitude: number
}) => {
    const {addressDisplayName, latitude, longitude} = props;
    return (
        <div className="carDetailsComposite__element carDetailsComposite__grey carDetailsComposite__no-border">
            <div className="carDetailsComposite__address">
                <img src="/images/icons/countries/republic-of-poland.svg" width="20"/>
                <span className="font-blue">
                        {addressDisplayName}
                    </span>
            </div>

            <Coordinates lat={latitude} lng={longitude}/>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Composites/_CompositesHelpers.tsx